<template>
    <aside class="side-menu">
        <slot></slot>
    </aside>
</template>

<script>
	export default {
		name: 'SideMenu'
	}
</script>

<style lang="scss" scoped>
    aside {
        background-color: #fff;
        padding: 20px;
        border: 1px solid #f5f5f5;
		overflow-y:auto;
    }
</style>
